const values = {
    "TOPUP_PRICES": "Precios",
    "TOPUP_PRODUCTS": "Productos",
    "ERROR_00_400_77": "Ya existe un precio para ese producto",
    "REMOVE_TOPUP_PRICE_CONFIRMATION": "¿Está seguro que desea eliminar el precio de recarga?",
    "REMOVE_TOPUP_PRICE": "Eliminar precio de recarga",
}

export default values;